// Support IE Edge, react-app-polyfill must be the first line
import { IconSprite } from "@ellucian/ds-icons/lib";
import CircularProgress from "@ellucian/react-design-system/core/es/CircularProgress";
import EDSApplication from "@ellucian/react-design-system/core/es/EDSApplication";
import Footer from "@ellucian/react-design-system/core/es/Footer";
import HeaderBar from "@ellucian/react-design-system/core/es/HeaderBar";
import Typography from "@ellucian/react-design-system/core/es/Typography";
import * as React from "react";
import "react-app-polyfill/ie11";
import * as ReactDOM from "react-dom";
import { IntlProvider } from "react-intl";
import withIntl, { IntlProps } from "../hoc/ReactIntlHOC";
import "../style/style.css";
import * as api from "../transitApp/TransitAPI/api";
import LoginForm from "./LoginForm";
import { getUserLocale } from "../transitApp/Utils/DateTimeUtils";
import { HeaderLogo } from "../transitApp/common/HeaderLogo";

const id = "Signin";

export class Page extends React.Component<IntlProps, {}> {
  constructor(props: any) {
    super(props);
  }

  render() {
    const { formatMessage, messages } = this.props.intl;

    return (
      <EDSApplication locale={getUserLocale()}
        labelOverrides={{
          'component.TextField.hidePassword': messages['transit.textField.hidePassword'],
          'component.TextField.passwordHide': messages['transit.textField.passwordHide'],
          'component.TextField.passwordShow': messages['transit.textField.passwordShow'],
          'component.TextField.showPassword': messages['transit.textField.showPassword'],
        }}
      >
        <div style={{ height: "100vh" }}>
          <IconSprite />
          <div id={`${id}_Container`}>
            <div className="loginBody">
              <HeaderBar position="static" id={`${id}_HeaderBar`}
                SearchTextFieldProps={{ inputProps: { 'aria-label': formatMessage({ id: 'transit.textField.search' }) } }}
              >
                <HeaderLogo id={`${id}_HeaderBarLogo`} ariaLabel={formatMessage({ id: 'transit.logo.logo' })} />
              </HeaderBar>
              <Typography
                id={`${id}_PageContent`}
                component="div"
                variant="body1"
                gutterBottom
                align="left"
              >
                <LoginForm />
              </Typography>
            </div>
            <div className="footerSignIn">
              <Footer
                footerText={formatMessage(
                  { id: "app.footer.copyright" },
                  { year: new Date().getFullYear() }
                )}
              />
            </div>
          </div>
        </div>
      </EDSApplication>
    );
  }
}

const StyledPage = withIntl(Page);
const i18nConfig = {
  en: {
    locale: "en",
  },
};

interface LoaderState {
  messages?: any;
}

export class Loader extends React.Component<{}, LoaderState> {
  constructor(props: any) {
    super(props);
    this.state = {};
    this.loadMessages();
  }
  async loadMessages() {
    const messages = await api.getMessages();
    this.setState({ messages });
  }

  render() {
    if (!this.state.messages) return <CircularProgress id="appLoadingStatus" />;
    return (
      <IntlProvider
        locale={i18nConfig.en.locale}
        messages={this.state.messages}
      >
        <StyledPage />
      </IntlProvider>
    );
  }
}

const APP_ID = 'login-app';
const element = document.createElement('div');
element.setAttribute('id', APP_ID);
document.body.appendChild(element);

ReactDOM.render(<Loader />, document.getElementById(APP_ID));
